import type { TWbaConfigParams, TWbaEventNames } from "./types";

import "./wba.js";

export const Analytics = {
  send(event: TWbaEventNames, params: TWbaConfigParams) {
    if (!globalThis.wba) return;

    globalThis.wba(event, params);
  },

  initSections() {
    const sections = [
      { id: "how", name: "От задания к награде" },
      { id: "about", name: "Целый город" },
      { id: "parents", name: "С заботой о детях" },
      { id: "steps", name: "Как добавить ребёнка" },
      { id: "faq", name: "Вопросы и ответы" },
    ];

    const seen = new Set();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !seen.has(entry.target.id)) {
            seen.add(entry.target.id);
            const section = sections.find((s) => s.id === entry.target.id);
            if (section) {
              this.send("section_s", { location: "landing", name: section.name });
            }
          }
        });
      },
      { threshold: 0.2 }
    );

    sections.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
  },

  initButton() {
    const button = document.getElementById("try");

    if (!button) return;

    button.addEventListener("click", () => {
      this.send("auth_t", { location: "landing" });
    });
  },

  init() {
    this.initSections();
    this.initButton();
  },
};
